import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { UserService } from "@app/services/user.service";
import { Observable, from } from "rxjs";
import { map, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root", // Ensuring singleton service and tree-shakable
})
export class RootGuardService {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return from(this.userService.hasAccess("catalog-builder")).pipe(
      tap((hasAccess) => {
        if (hasAccess) {
          this.router.navigate(["/catalogs/list"]);
        } else {
          this.router.navigate(["/ads/list"]);
        }
      }),
      map(() => false) // Assuming you want to always navigate away, thus never activating the current route
    );
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }
}
